import {
  SortOrder,
  getSortOrderIcon,
  getSortOrderName,
} from "shared-ts/hooks/useSort/helpers"

import { Button } from "../../../../../components/base/control/Button"
interface SortPopoverDirectionToggleProps {
  onClick: () => void
  sortOrder: SortOrder
}

export function SortPopoverDirectionToggle({
  onClick,
  sortOrder,
}: SortPopoverDirectionToggleProps) {
  return (
    <Button
      mode="secondary"
      onClick={onClick}
      className="flex flex-row gap-2 px-1 py-1 pr-2"
      leftIcon={getSortOrderIcon(sortOrder)}
      size="small"
    >
      {getSortOrderName(sortOrder)}
    </Button>
  )
}
